<template>
    <div class="container my-5" style="max-width: 900px;">
        <!-- Header -->
        <div class="d-flex justify-content-between align-items-center mb-4">
            <h2 class="font-weight-bold mb-0">Filter management</h2>
            <div>
                <button class="btn btn-primary mr-2" @click="saveAllFilters">
                    <i class="fa fa-save"></i> บันทึกทั้งหมด
                </button>
                <!--  ปุ่มเพิ่ม Filter หลัก -->
                <button class="btn btn-success" @click="openAddMainModal">
                    <i class="fa fa-plus"></i> เพิ่ม Filter หลัก
                </button>
            </div>
        </div>


        <!-- Loading -->
        <div v-if="isLoading" class="text-center my-4">
            <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <p class="mt-2">กำลังโหลดข้อมูล...</p>
        </div>

        <!-- Error -->
        <div v-if="errorMessage" class="alert alert-danger">
            {{ errorMessage }}
        </div>

        <!-- Filters -->
        <div v-for="(filter, i) in filters" :key="filter.id || i" class="card shadow-sm mb-4 border-0">
            <div class="card-header bg-white d-flex justify-content-between align-items-center">
                <h5 class="mb-0 font-weight-bold">{{ filter.title }}</h5>
                <div>
                    <button class="btn btn-outline-secondary btn-sm mr-1" @click="moveFilterUp(i)">
                        <i class="fa fa-arrow-up"></i>
                    </button>
                    <button class="btn btn-outline-secondary btn-sm mr-1" @click="moveFilterDown(i)">
                        <i class="fa fa-arrow-down"></i>
                    </button>
                    <button class="btn btn-warning btn-sm text-white mr-1" @click="openEditMainModal(i)">
                        <i class="fa fa-pencil"></i>
                    </button>
                    <button class="btn btn-danger btn-sm text-white" @click="deleteMainFilter(i, j)">
                        <i class="fa fa-trash"></i>
                    </button>


                </div>
            </div>

            <!-- หัวข้อย่อย -->
        <ul
        v-if="filter.select_items && filter.select_items.length"
        class="list-group list-group-flush"
        >
            <li
                v-for="(item, j) in filter.select_items"
                :key="j"
                class="list-group-item d-flex justify-content-between align-items-center"
            >
                <div class="d-flex align-items-center">
                <img
                    v-if="item.icon"
                    :src="item.icon"
                    alt="icon"
                    class="me-2"
                    style="width: 28px; height: 28px; object-fit: contain;"
                />
                <span>{{ item.title }}</span>
                </div>

                <div>
                <button class="btn btn-outline-secondary btn-sm mr-1" @click="moveItemUp(i, j)">
                    <i class="fa fa-arrow-up"></i>
                </button>
                <button class="btn btn-outline-secondary btn-sm mr-1" @click="moveItemDown(i, j)">
                    <i class="fa fa-arrow-down"></i>
                </button>
                <button class="btn btn-warning btn-sm text-white mr-1" @click="openEditModal(i, j)">
                    <i class="fa fa-pencil"></i>
                </button>
                <button class="btn btn-danger btn-sm text-white" @click="deleteSubFilter(i, j)">
                    <i class="fa fa-trash"></i>
                </button>
                </div>
            </li>
        </ul>

            <div class="card-footer bg-white text-right">
                <button class="btn btn-success btn-sm" @click="addSubFilter(i)">
                    <i class="fa fa-plus"></i> เพิ่ม Filter ย่อย
                </button>
            </div>

        </div>

        <!-- เมื่อไม่มีข้อมูล -->
        <div v-if="!isLoading && filters.length === 0" class="alert alert-secondary">
            ไม่พบข้อมูล Filter
        </div>

        <!-- Modal แก้ไข Filter ย่อย -->
        <div v-if="isEditModalOpen" class="modal fade show d-block" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content p-3">
                    <div class="modal-header">
                        <h5 class="modal-title">แก้ไข Filter ย่อย</h5>
                        <button type="button" class="btn-close" @click="closeEditModal">X</button>
                    </div>

                    <div class="modal-body">
                        <div class="form-group mb-3">
                            <label>ชื่อหัวข้อ (Title)</label>
                            <input v-model="editForm.title" type="text" class="form-control" />
                        </div>

                        <div class="form-group mb-3">
                            <label>Slug</label>
                            <input v-model="editForm.slug" type="text" class="form-control" />
                        </div>

                        <div class="border p-3 rounded">
                            <h6 class="text-secondary mb-3">Icon สำหรับ Filter ย่อย</h6>

                            <!-- Preview -->
                            <div v-if="editForm.icon" class="text-center mb-3">
                                <div class="position-relative d-inline-block">
                                    <img :src="editForm.icon" alt="icon preview" class="img-thumbnail"
                                        style="max-height: 80px;" />
                                    <!-- ปุ่มลบรูป -->
                                    <button class="btn btn-sm btn-danger position-absolute"
                                        style="top: -10px; right: -10px; border-radius: 50%;" @click="clearSelectedIcon"
                                        title="ลบรูป">
                                        <i class="fa fa-times"></i>
                                    </button>
                                </div>
                                <div class="small text-muted mt-1">เลือกรูปใหม่ได้โดยการค้นหาอีกครั้ง</div>
                            </div>

                            <!-- ช่องค้นหา -->
                            <div v-else>
                                <div class="input-group mb-3">
                                    <input v-model="searchKeyword" type="text" class="form-control"
                                        placeholder="พิมพ์คำค้นหารูปภาพ" @keyup.enter="searchSubFilterIcon" />
                                    <button class="btn btn-outline-primary" @click="searchSubFilterIcon">
                                        <i class="fa fa-search"></i> ค้นหา
                                    </button>
                                </div>

                                <!-- Loading -->
                                <div v-if="isSearching" class="text-center text-muted">
                                    <i class="fa fa-spinner fa-spin"></i> กำลังค้นหา...
                                </div>

                                <!-- แสดงรายการรูป -->
                                <div v-if="!isSearching && subFilterIcons.length"
                                    class="d-flex flex-wrap gap-2 justify-content-start">
                                    <div v-for="(img, index) in subFilterIcons" :key="img.id"
                                        class="border rounded p-1 m-1"
                                        style="width: 90px; text-align: center; cursor: pointer;"
                                        @click="selectSubFilterIcon(img)">
                                        <img :src="img.src" :alt="img.alt" class="img-fluid rounded mb-1"
                                            style="max-height: 60px;" />
                                        <div class="small text-truncate">{{ img.alt }}</div>
                                    </div>
                                </div>

                                <!-- ไม่มีรูป -->
                                <div v-if="!isSearching && !subFilterIcons.length" class="text-center text-muted">
                                    ไม่พบรูปภาพ
                                </div>

                                <!-- ปุ่มเพิ่มภาพใหม่ -->
                                <div class="text-end mt-3">
                                    <a href="/media/form" target="_blank" class="btn btn-secondary btn-sm">
                                        <i class="fa fa-plus"></i> เพิ่มภาพใหม่
                                    </a>
                                </div>
                            </div>
                        </div>

                    </div>




                    <div class="modal-footer">
                        <button class="btn btn-secondary" @click="closeEditModal">ยกเลิก</button>
                        <button class="btn btn-success" @click="saveEditItem">บันทึก</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- ✅ Modal แก้ไข Filter หลัก -->
        <div v-if="isEditMainModalOpen" class="modal fade show d-block" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content p-3">
                    <div class="modal-header">
                        <h5 class="modal-title">แก้ไข Filter หลัก</h5>
                        <button type="button" class="btn-close" @click="closeEditMainModal">X</button>
                    </div>

                    <div class="modal-body">
                        <div class="form-group mb-3">
                            <label>ชื่อหัวข้อ (Title)</label>
                            <input v-model="editMainForm.title" type="text" class="form-control" />
                        </div>
                        <div class="form-group mb-3">
                            <label>ประเภท (Type)</label>
                            <input v-model="editMainForm.type" type="text" class="form-control"
                                placeholder="option, price, color..." />
                        </div>
                        <div class="form-group mb-3">
                            <label>ประเภทปุ่ม (Button Type)</label>
                            <select v-model="editMainForm.button_type" class="form-control">
                                <option value="2">Radio</option>
                                <option value="1">Button</option>
                            </select>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button class="btn btn-secondary" @click="closeEditMainModal">ยกเลิก</button>
                        <button class="btn btn-success" @click="saveEditMainFilter">บันทึก</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- ✅ Modal เพิ่ม Filter หลัก -->
        <div v-if="isAddMainModalOpen" class="modal fade show d-block" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content p-3">
                    <div class="modal-header">
                        <h5 class="modal-title">เพิ่ม Filter หลัก</h5>
                        <button type="button" class="btn-close" @click="closeAddMainModal">X</button>
                    </div> <label>ชื่อหัวข้อ (Title)</label>

                    <div class="modal-body">
                        <div class="form-group mb-3">
                            <label>ชื่อหัวข้อ (Title)</label>
                            <input v-model="newMainForm.title" type="text" class="form-control"
                                placeholder="กรอกชื่อหัวข้อหลัก" />
                        </div>

                        <div class="form-group mb-3">
                            <label>ประเภท (Type)</label>
                            <input v-model="newMainForm.type" type="text" class="form-control"
                                placeholder="option, price, color..." />
                        </div>

                        <div class="form-group mb-3">
                            <label>ประเภทปุ่ม (Button Type)</label>
                            <select v-model="newMainForm.button_type" class="form-control">
                                <option value="2">Radio</option>
                                <option value="1">Button</option>
                            </select>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button class="btn btn-secondary" @click="closeAddMainModal">ยกเลิก</button>
                        <button class="btn btn-success"
                            :disabled="!newMainForm.title.trim() || !newMainForm.type.trim()"
                            @click="saveAddMainFilter">
                            บันทึก
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- ✅ Backdrop -->
        <div v-if="isEditModalOpen || isEditMainModalOpen || isAddMainModalOpen" class="modal-backdrop fade show"></div>
    </div>

</template>



<script setup>
import { ref, onMounted } from "vue";
import axios from "axios";


const isAddMainModalOpen = ref(false);
const newMainForm = ref({
    title: "",
    type: "option",
    button_type: "2",
    is_show: true,
    multiple_select: false,
    select_items: [],
});
const base_url = "/product-filter/list_filter";

const filters = ref([]);
const isLoading = ref(false);
const errorMessage = ref("");
const isEditModalOpen = ref(false);
const editFilterIndex = ref(null);
const editItemIndex = ref(null);
const editForm = ref({
    title: "",
    slug: "",
    icon: "",
});



function openAddMainModal() {
    isAddMainModalOpen.value = true;
}


function closeAddMainModal() {
    isAddMainModalOpen.value = false;
    newMainForm.value = {
        title: "",
        type: "option",
        button_type: "2",
        is_show: true,
        multiple_select: false,
        select_items: [],
    };
}
function selectSubFilterIcon(img) {
    editForm.value.icon = img.src;
    subFilterIcons.value = [];
}

function clearSelectedIcon() {
    editForm.value.icon = "";
    searchSubFilterIcon();
}

function saveAddMainFilter() {
    const { title, type } = newMainForm.value;
    if (!title.trim() || !type.trim()) return;

    const newFilter = {
        ...newMainForm.value,
        priority_slug: (filters.value.length + 1).toString(),
    };

    filters.value.push(newFilter);
    closeAddMainModal();
}

const isEditMainModalOpen = ref(false);
const editMainIndex = ref(null);
const editMainForm = ref({
    title: "",
    type: "",
    button_type: "2",
});

async function saveAllFilters() {

    const payload = {
        name: "ฟิลเตอร์หลัก",
        active: 1,
        description: "ตัวม๊อคอัพ",
        filters: filters.value.map((filter, i) => ({
            title: filter.title || `Filter ${i + 1}`,
            type: filter.type || "option",
            is_show: filter.is_show ?? true,
            multiple_select: filter.multiple_select ?? false,
            icon: filter.icon ?? null,
            button_type: filter.button_type ?? "2",
            priority_slug: (i + 1).toString(),
            select_items: (filter.select_items || []).map((item) => ({
                title: item.title || "ไม่มีชื่อ",
                custom_params: item.custom_params ?? null,
                related_tags: item.related_tags ?? [
                    {
                        key: filter.title || "ไม่ระบุ",
                        value: item.title || "ไม่ระบุค่า",
                    },
                ],
                related_tags_operator: item.related_tags_operator ?? "or",
                icon: item.icon ?? null,
                slug: item.slug || item.title?.toLowerCase().replace(/\s+/g, "-") || "",
                _processed_query_params:
                    item._processed_query_params ??
                    `tag_values[]=${item.title || "ไม่ระบุ"}`,
            })),
        })),
    };



    try {
        const response = await axios.post("/product-filter/list_filter", payload);
        console.log("✅ บันทึกสำเร็จ:", response.data);
        alert("บันทึกข้อมูลสำเร็จ!");
    } catch (error) {
        console.error("❌ บันทึกไม่สำเร็จ:", error);
        alert("เกิดข้อผิดพลาดในการบันทึกข้อมูล");
    }

}


function addSubFilter(filterIndex) {
    const newItem = {
        title: "กรอกชื่อ Filter ใหม่",
        slug: "",
        icon: "",
    };

    if (!filters.value[filterIndex].select_items) {
        filters.value[filterIndex].select_items = [];
    }

    filters.value[filterIndex].select_items.push(newItem);

    const newIndex = filters.value[filterIndex].select_items.length - 1;
    openEditModal(filterIndex, newIndex);
}

function deleteMainFilter(index) {
    if (!confirm("เมื่อลบแล้วกลุ่มนี้จะไม่แสดงบนหน้าเว็บ และไม่สามารถแก้ไขกลับไป\n ยืนยันการลบข้อมูล?")) return;
    filters.value.splice(index, 1);
}


function deleteSubFilter(filterIndex, itemIndex) {
    if (!confirm("เมื่อลบแล้ว filter นี้จะไม่แสดงบนหน้าเว็บ และไม่สามารถแก้ไขกลับไป\n ยืนยันการลบข้อมูล?")) return;

    const items = filters.value[filterIndex].select_items;
    items.splice(itemIndex, 1);
}


function openEditMainModal(index) {
    editMainForm.value = { ...filters.value[index] };
    editMainIndex.value = index;
    isEditMainModalOpen.value = true;
}

function closeEditMainModal() {
    isEditMainModalOpen.value = false;
    editMainForm.value = { title: "", type: "", button_type: "2" };
    editMainIndex.value = null;
}

function saveEditMainFilter() {
    if (editMainIndex.value === null) return;
    filters.value[editMainIndex.value] = {
        ...filters.value[editMainIndex.value],
        ...editMainForm.value
    };
    closeEditMainModal();
}



function openEditModal(filterIndex, itemIndex) {
    const item = filters.value[filterIndex].select_items[itemIndex];
    editForm.value = { ...item };
    editFilterIndex.value = filterIndex;
    editItemIndex.value = itemIndex;
    isEditModalOpen.value = true;
}

function closeEditModal() {
    isEditModalOpen.value = false;
    editForm.value = { title: "", slug: "", icon: "" };
    editFilterIndex.value = null;
    editItemIndex.value = null;
}

function saveEditItem() {
    if (editFilterIndex.value === null || editItemIndex.value === null) return;
    filters.value[editFilterIndex.value].select_items[editItemIndex.value] = {
        ...editForm.value,
    };
    closeEditModal();
}


async function load() {
    isLoading.value = true;
    errorMessage.value = "";

    try {
        console.log("🔍 Calling API:", base_url);
        const response = await axios.get(base_url,);
        console.log("✅ API Response:", response.data);

        if (response.data && Array.isArray(response.data.filters)) {
            filters.value = response.data.filters;
        } else if (Array.isArray(response.data)) {
            filters.value = response.data;
        } else {
            filters.value = [];
        }
    } catch (error) {
        console.error("❌ loading filters error:", error);
        errorMessage.value = "เกิดข้อผิดพลาดในการโหลดข้อมูล Filter";
    } finally {
        isLoading.value = false;
    }
}

function moveFilterUp(index) {
    if (index === 0) return;
    const temp = filters.value[index];
    filters.value.splice(index, 1);
    filters.value.splice(index - 1, 0, temp);
}

function moveFilterDown(index) {
    if (index === filters.value.length - 1) return; 
    const temp = filters.value[index];
    filters.value.splice(index, 1);
    filters.value.splice(index + 1, 0, temp);
}


function moveItemUp(filterIndex, itemIndex) {
    const items = filters.value[filterIndex].select_items;
    if (itemIndex === 0) return;
    const temp = items[itemIndex];
    items.splice(itemIndex, 1);
    items.splice(itemIndex - 1, 0, temp);
}

function moveItemDown(filterIndex, itemIndex) {
    const items = filters.value[filterIndex].select_items;
    if (itemIndex === items.length - 1) return;
    const temp = items[itemIndex];
    items.splice(itemIndex, 1);
    items.splice(itemIndex + 1, 0, temp);
}

const subFilterIcons = ref([]);
const searchKeyword = ref("");
const isSearching = ref(false);

async function searchSubFilterIcon() {

    subFilterIcons.value = [];
    isSearching.value = true;

    const url = `/media/list?perpage=20&mime_types=jpeg,jpg,png,gif,webp&title=${encodeURIComponent(searchKeyword.value)}`;

    try {
        const response = await axios.get(url);
        const items = response.data.media;

        if (items) {
            Object.entries(items).forEach(([key, item]) => {
                subFilterIcons.value.push({
                    id: item.id,
                    src: item.url,
                    alt: item.original_name,
                });
            });
        }
    } catch (error) {
        console.error("❌ Error searching icons:", error);
    } finally {
        isSearching.value = false;
    }
}


onMounted(() => {
    load();
});
</script>


<style scoped>
.card-header h5 {
    font-size: 1.1rem;
}

.list-group-item {
    font-size: 0.95rem;
}
</style>
